import React from 'react';
import loadable from '@loadable/component';

import unsubscribeQuery from './unsubscribe-landing-page-query.graphql';
import type { Props } from './unsubscribe-landing-page';

export const Unsubscribe = loadable(
  () => import(/* webpackChunkName: "profile" */ './unsubscribe-landing-page')
);

// Fixes loadable type errors `Property 'graphQL' does not exist on type`

const UnsubscribeLandingPage = (props: Props) => {
  return <Unsubscribe {...props} />;
};

type QueryVariables = {
  // eslint-disable-next-line camelcase
  group_id: string;
  // eslint-disable-next-line camelcase
  user_id: string;
  hash: string;
};

UnsubscribeLandingPage.variables = (props: QueryVariables) => ({
  id: props.group_id,
  subscribed: false,
  userID: props.user_id,
  hash: props.hash,
});

UnsubscribeLandingPage.graphQL = unsubscribeQuery;

export default UnsubscribeLandingPage;
